import _ from 'lodash';
import React, { Component } from 'react';

import { defaults, Pie, Doughnut } from 'react-chartjs-2';
import Color from 'color';

//import logo from '../../assets/images/logos/Icon@2x.png';
//import dimensionsOverview from '../../assets/images/playbook/Dimensions-Overview.svg';
import dimensionsOverview from '../../assets/images/playbook/Dimensions-Overview-Labelless-V2.svg';
import aiqLogo from '../../assets/images/playbook/AIQ_Reversed_Logo.svg';

import {
  colorForCategory,
  getDimensionsForCategory,
  getScoreClassificationInOrderedGroupScores,
  getCategoryNameFromId,
  getDimensionFromId,
  getIcon,
  sellingCompetencies,
} from '../../util';

import {
  getOrderedDimensionScores,
  scoreCompetitiveAdvantagesForTalentProfile,
  DIMENSION_CATEGORY_IDS,
  getTalentProfiles,
} from '../../util/data';

import {
  localizeToString,
} from '../../util/localizers';

import {
  Localize
} from '../shared';

import { iconForTalentCategory } from '../../util/icons';

// Disable animating charts by default.
defaults.global.animation = false;
defaults.pie.animation.animateRotate = false;
defaults.pie.animation.animateScale = false;
defaults.global.tooltips.enabled = false;
defaults.global.elements.arc.backgroundColor = 'rgba(0,0,0,.1)';


class PlaybookReport extends Component {

  renderLoadingMessage(){
    return <p>Loading...</p>;
  }

  talentProfileId(){
    return this.props.reportData.profile;
  }
  talentProfileData(){
    return this.talentProfileId() ? getTalentProfiles()[this.talentProfileId()] : null;
  }
  talentProfileType(){
    return (this.talentProfileData() || {}).profileType;
  }
  orgId(){
    return this.props.reportData.organization;
  }
  batchLabel(){
    return this.props.reportData.batchLabel || false;
  }
  userName(){
    return this.props.reportData.firstName + ' ' + this.props.reportData.lastName;
  }
  scores(){
    const allScores = this.props.reportData.scores;
    const allTalentProfiles = getTalentProfiles();
    const scoredProfile = allTalentProfiles[this.talentProfileId()];

    // console.log('allScores: ', allScores);
    // console.log('scoredProfile: ', scoredProfile);

    let scoresForProfile = {};

    _.each(scoredProfile.scoredDimensions, scoredDimensionForProfile => {
      scoresForProfile[scoredDimensionForProfile] = allScores[scoredDimensionForProfile];
    });

    // console.log('scoresForProfile: ', scoresForProfile);

    return scoresForProfile;
  }

  renderPieChart(chartData){
    return <Pie legend={{display:false}} ref='chart' options={{maintainAspectRatio:false}} data={chartData} />
  }
  renderDimensionPieChart(chartData){
    return <Doughnut legend={{display:false}} ref='chart' options={{maintainAspectRatio:false, cutoutPercentage: 35}} data={chartData} />
  }

  orderedDimensionCategories(){
    const orderedDimensionCategories = getOrderedDimensionScores(this.scores(), 2.5);
    return orderedDimensionCategories;
  }

  fadeColorForCategory(category, amount = 0){
    const categoryColor = Color(colorForCategory(category));

    return categoryColor.fade(amount).rgb().string();
  }

  chartDataForDimensionInCategory(category){

    return {
      datasets: [{
        data: [25,25,25,25],
        backgroundColor: _.map(DIMENSION_CATEGORY_IDS, categoryId => { return this.fadeColorForCategory(categoryId, categoryId === category ? 0 : .5) })
      }]
    }
  }
  chartDataForCategory(category = 'all'){

    if(category === 'all'){
      const orderedDimensionCategories = this.orderedDimensionCategories();

      return {
        datasets: [{
          data: _.map(orderedDimensionCategories, 'percent'),
          backgroundColor: _.map(_.map(orderedDimensionCategories, 'id'), colorForCategory)
        }]
      }
    }
    else{
      const categoryColor = Color(colorForCategory(category.id));

      return {
        datasets: [{
          data: _.map(category.dimensions, 'percent'),
          backgroundColor: [categoryColor.rgb().string(), categoryColor.fade(.2).rgb().string(), categoryColor.fade(.4).rgb().string(), categoryColor.fade(.6).rgb().string(), categoryColor.fade(.8).rgb().string()]
        }]
      }
    }
  }

  renderStrengthsScores(){
    const categories = this.orderedDimensionCategories();

    return(
      <div className="strengths-scores tall">
        <div className="pie">
          <div className="chart-container">
            {this.renderPieChart(this.chartDataForCategory('all'))}
          </div>
        </div>

        {_.map(categories, category => {

          const categoryScoreClassification = getScoreClassificationInOrderedGroupScores(category.percent, _.map(categories, 'percent'));

          return (
            <div key={category.id} className={`strength ${category.id}`}>
              <div className="name"><Localize id={`dimension_category_${category.id}_label`} /></div>
              <div className="percent" style={{color: colorForCategory(category.id)}}>{Math.round(category.percent)}%</div>
              {categoryScoreClassification === 'high' &&
                <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}><Localize id="txt_label_strongcategory">Strong Category</Localize></div>
              }
              {categoryScoreClassification === 'low' &&
                <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}><Localize id="txt_label_weakcategory">Weak Category</Localize></div>
              }
            </div>
          );
        })}
      </div>
    )
  }

  renderScoresForCategory(category){

    //console.log('renderScoresForCategory: ', category);

    return(
      <div className={`strengths-scores ${category.dimensions.length === 3 ? 'three-wide' : ''}${category.dimensions.length === 5 ? 'five-wide' : ''} tall`}>
        <div className="pie">
          <div className="chart-container">
            {this.renderPieChart(this.chartDataForCategory(category))}
          </div>
        </div>

        {_.map(category.dimensions, (dimension, index) => {

          const talentScoreClassification = getScoreClassificationInOrderedGroupScores(dimension.percent, _.map(category.dimensions, 'percent'));

          return (
            <div key={dimension.id} className={`strength ${dimension.id}`}>
              <div className="name">{this.getDimensionLabel(dimension.id)}</div>
              <div className="percent">{Math.round(dimension.percent)}%</div>
                {talentScoreClassification === 'high' &&
                  <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}><Localize id="txt_label_strongtalent">Strong Talent</Localize></div>
                }
                {talentScoreClassification === 'low' &&
                  <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}><Localize id="txt_label_weaktalent">Weak Talent</Localize></div>
                }
            </div>
          );
        })}
      </div>
    )
  }

  renderSingleScorePie(percentage, color){
    const dataForPie = {
      datasets: [{
        data: [percentage, (100 - percentage)],
        backgroundColor: [color,'rgba(0,0,0,.1)'],
      }]
    }

    return <Pie legend={{display:false}} ref='chart' options={{maintainAspectRatio:false}} data={dataForPie} />
  }

  getScoreLabel(score, isCategory, scoreClassification = false){

    const roundedScore = Math.round(score);

    if(!scoreClassification){
      return roundedScore + '%';
    }
    else if(scoreClassification === 'high'){
      if(isCategory){
        return <span>{roundedScore} % - <Localize id="txt_label_strongcategory">Strong Category</Localize></span>
      }
      else{
        return <span>{roundedScore} % - <Localize id="txt_label_strongtalent">Strong Talent</Localize></span>
      }
    }
    else if(scoreClassification === 'low'){
      if(isCategory){
        return <span>{roundedScore} % - <Localize id="txt_label_weakcategory">Weak Category</Localize></span>
      }
      else{
        return <span>{roundedScore} % - <Localize id="txt_label_weaktalent">Weak Talent</Localize></span>
      }
    }
    else{
      return roundedScore + '%';
    }
  }

  getScoredDimensionIds(){
    return _.map(this.scores(), (scoresForDimensions, dimensionId) => {
      return dimensionId;
    });
  }

  renderDimensionLabel(dimensionId){
    return (
      <span key={`predictive-talent-${dimensionId}`} className="dimension">{this.getDimensionLabel(dimensionId)}</span>
    )
  }

  renderDimensionCategories(){

    let self = this;

    const categories = this.orderedDimensionCategories();

    return(
      <div className="talents">
        {_.map(categories, category => {

          const categoryScoreClassification = getScoreClassificationInOrderedGroupScores(category.percent, _.map(categories, 'percent'));
          const categoryDimensions = getDimensionsForCategory(this.getScoredDimensionIds(), category.id);

          return (
            <div key={'category-definition-' + category.id} className="talent">
              <div className="talent-summary">
                <div className="talent-name"><Localize id={`dimension_category_${category.id}_label`} /></div>
                <div className="chart-container">
                  {this.renderSingleScorePie(category.percent, colorForCategory(category.id))}
                </div>
                <div className="percent" style={{color: colorForCategory(category.id)}}>{this.getScoreLabel(category.percent, true, categoryScoreClassification)}</div>
              </div>
              <div className="talent-info">
                <p><Localize id={`dimension_category_${category.id}_description`}>Missing Talent Category Description</Localize></p>
                {categoryScoreClassification === 'high' &&
                  <p><Localize id={`dimension_category_${category.id}_high_description`}>Missing Talent Category "High" Description</Localize></p>
                }
                {categoryScoreClassification === 'low' &&
                  <p><Localize id={`dimension_category_${category.id}_low_description`}>Missing Talent Category "Low" Description</Localize></p>
                }
                <div className="competency">&gt; &nbsp;<Localize id="txt_label_predictivetalents">Predictive Talents</Localize>: <div className="predictive-talents-list">{_.map(categoryDimensions, this.renderDimensionLabel.bind(this))}</div></div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  getCompetencyForDimension(dimensionId){
    const competencies = sellingCompetencies();

    return _.find(competencies, competency => {
      return competency.primaryDimensions.indexOf(dimensionId) !== -1;
    });
  }

  renderDimensionsForCategory(category){
    return(
      <div className="talents">
        {_.map(category.dimensions, dimension => {

          const dimensionScoreClassification = getScoreClassificationInOrderedGroupScores(dimension.percent, _.map(category.dimensions, 'percent'));

          return (
            <div key={'category-definition-' + dimension.id} className="talent">
              <div className="talent-summary">
                <div className="talent-name">{this.getDimensionLabel(dimension.id)}</div>
                <div className="chart-container">
                  {this.renderSingleScorePie(dimension.percent, colorForCategory(category.id))}
                </div>
                <div className="percent" style={{color: colorForCategory(category.id)}}>{this.getScoreLabel(dimension.percent, false, dimensionScoreClassification)}</div>
              </div>
              <div className="talent-info">
                <p><Localize id={`${this.tbarTypeLocalizationPrefix()}dimension_${dimension.id}_definition`} breakType="dot"/></p>
                <p className="competency">&gt; &nbsp;<Localize id="playbook_primary_selling_competency_label">Primary Selling Competency</Localize>: {this.getCompetencyForDimension(dimension.id).name}</p>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  renderFooterForPage(pageNumber){
    return (
      <div className="page-footer">
        {this.renderCopyright()}
        {this.renderPageNumber(pageNumber)}
        {this.renderPreparedForUser()}
      </div>
    )
  }

  renderCopyright(){
    return (
      <div className="copyright">&copy; 2019 AuctusIQ, LLC</div>
    )
  }

  renderPreparedForUser(){
    return (
      <div className="prepared-for"><Localize id="txt_label_preparedfor">Prepared for</Localize> {this.userName()}&nbsp;&middot;&nbsp;</div>
    )
  }

  renderPageNumber(number){
    return (
      <div className="page-marker"><Localize id="txt_label_page">Page</Localize> {number}</div>
    )
  }

  renderCategoryPage(category, index){
    return (
      <div key={'page-' + category.id} className="report-know-your-strengths report-page">
        <img className="report-logo" src={this.companyLogo()} alt={this.companyName()} />
        <h2><Localize id={`dimension_category_${category.id}_heading`}>Missing</Localize></h2>
        {this.renderScoresForCategory(category)}
        {this.renderDimensionsForCategory(category)}
        {this.renderFooterForPage(index + 5)}
      </div>
    )
  }

  renderPlayToYourStrengthsReport(){

    const orderedDimensionCategories = this.orderedDimensionCategories();

    return (
      <template>
        <div className="page playbook-v2">
          <div className="report-play-to-your-strengths report-page">
            <img className="report-logo" src={this.companyLogo()} alt={this.companyName()} />
            <h1>
              <Localize id="playbook_ptys_report_label" /><br/>
              {this.renderPreparedFor()}
            </h1>
            <div className="report-section" style={{paddingTop: '0px'}}>
              <p>
                <Localize id="playbook_ptys_top_section" />
              </p>
            </div>
            <div className="report-section full-width-with-icon">
              <div className="section-icon">{iconForTalentCategory(orderedDimensionCategories[0].id)}</div>
              <div className="section-title"><Localize id="txt_label_leadingcategorypre">Your Leading Category</Localize>: <Localize id={`dimension_category_${orderedDimensionCategories[0].id}_label`} /></div>
              <div className="section-content large-font">
                <Localize id={`dimension_category_${orderedDimensionCategories[0].id}_leading_description`} />
              </div>
            </div>
            <div className="report-section no-bottom-border">
              <p>
                <Localize id="playbook_ptys_bottom_section" />
              </p>
            </div>
            {this.renderFooterForPage(9)}
          </div>
        </div>

        <div className="page playbook-v2">
          <div className="report-play-to-your-strengths report-page">
            <img className="report-logo" src={this.companyLogo()} alt={this.companyName()} />
            <h1><Localize id={`txt_label_report_ptys`}>Play To Your Strengths</Localize><br/><small className="prepared-for" style={{textTransform: 'capitalize'}}>{this.userName()}</small></h1>

            {_.map(orderedDimensionCategories, (dimensionCategory, index) => {

              return (
                <div key={'top-talent-definition-for-category-' + dimensionCategory.id} className={'report-section has-icon ' + (index === 3 ? 'no-bottom-border' : '')}>
                  <div className="section-icon">{iconForTalentCategory(dimensionCategory.id)}</div>
                  <div className="section-title"><Localize id={`dimension_category_${dimensionCategory.id}_top_talent_label`}>Missing category top talent label.</Localize>: {this.getDimensionLabel(dimensionCategory.dimensions[0].id)}</div>
                  <div className="section-content">
                    <Localize id={`${this.tbarTypeLocalizationPrefix()}dimension_${dimensionCategory.dimensions[0].id}_leading_description`} />
                  </div>
                </div>
              );
            })}
            {this.renderFooterForPage(10)}
          </div>
        </div>
      </template>
    )
  }

  renderKnowYourStrengthsReport(){
    return (
      <div className="page playbook-v2">
        <div className="report-know-your-strengths report-page">
          <img className="report-logo" src={this.companyLogo()} alt={this.companyName()} />
          <h1><Localize id={`txt_label_report_kys`}>Know Your Strengths</Localize><br/>{this.renderPreparedFor()}</h1>
          {this.renderStrengthsScores()}
          {this.renderDimensionCategories()}
          {this.renderFooterForPage(4)}
        </div>

        {_.map(this.orderedDimensionCategories(), this.renderCategoryPage.bind(this))}
      </div>
    )
  }

  talentProfileLabel(){
    return <Localize id={`talent_profile_${this.talentProfileId()}_label`} />;
  }

  renderTitlePage(){
    return (
      <div className="page playbook-v2">
        <div className="report-page title-page">
          <p className="whole-page-intro"><Localize id="txt_label_resultsshownbelow">Your assessment results are shown below. Download this report to keep a local copy of your talent playbook.</Localize></p>
          {this.batchLabel() &&
            <div className="group-label">{this.batchLabel()}</div>
          }
          <h1>{this.talentProfileLabel()}<span className="playbook-label"><Localize id={`playbook_name`}>Playbook</Localize></span></h1>
          <img className="report-title-logo" src={this.companyLogoDark()} />
          <img className="aiq-logo" src={aiqLogo} />
          <h6>&copy;Copyright 2019 AuctusIQ, LLC</h6>
        </div>
      </div>
    )
  }

  //TODO this currently is undefined for all companies. If I update to be "name", it will populate, but some companies have localizations that include the company namein the talent profile...
  //so I'm not going to do this.
  companyName(){
    return this.props.orgConfig.displayName || '';
  }

  companyLogo(){
    return this.props.orgConfig.logo;
  }
  companyLogoDark(){
    console.log(this.props.orgConfig);
    return this.props.orgConfig.logoDark || this.companyLogo();
  }

  tbarTypeLocalizationPrefix(){
    return `tbar_${this.talentProfileType()}_`;
  }

  getDimensionLabel(dimensionId, log){
    if(log){
      console.log('getting dimension label for ', dimensionId);
      console.log('ids: ', [`dimension_label_${dimensionId}_for_profile_${this.talentProfileId()}`, `dimension_label_${dimensionId}`]);
    }
    return <Localize ids={[`dimension_label_${dimensionId}_for_profile_${this.talentProfileId()}`, `dimension_label_${dimensionId}`]}>(Missing)</Localize>;
  }

  renderAssociatedSellingCompetencyForDimension(dimensionId){

    const associatedCompetency = this.getCompetencyForDimension(dimensionId);

    return(
      <div className="associated-competency-graphic">
        <h6><Localize id="playbook_primary_selling_competency_label">Primary Selling Competency</Localize></h6>
        <div className="fuels-text">{this.getDimensionLabel(dimensionId)} talent fuels competency for "{associatedCompetency.name}"</div>
        <div className="competencies-list">
          {_.map(sellingCompetencies(), (competency, index) => {

            const isActive = associatedCompetency.id === competency.id;

            return (
              <div key={`competency-${index}`} className={`competency-item ${isActive ? 'active' : ''}`}>
                {!isActive &&
                  <React.Fragment>
                    <div className="number">{index + 1}</div>
                    {getIcon('competency-badge')}
                  </React.Fragment>
                }
                {isActive &&
                  <React.Fragment>
                    <div className="badge-start">{getIcon('competency-badge')}</div>
                    <div className="number">{index + 1}</div>
                    <div className="name">{competency.name}</div>
                    <div className="badge-end">{getIcon('competency-badge')}</div>
                  </React.Fragment>
                }
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderDimensionsTrainingResource(dimensionId){

    const localizedText = localizeToString(this.props.activeLocalization, `${this.tbarTypeLocalizationPrefix()}dimension_${dimensionId}_training_resource`);
    const localizedTextLength = localizedText ? (localizedText.length || 0) : 0;

    return (
      <div className="dimension-training-resource">
        <h6><Localize id="playbook_training_resource">Training Resource</Localize></h6>
        <h5 className={localizedTextLength > 100 ? 'shrink-text' : ''}><Localize id={`${this.tbarTypeLocalizationPrefix()}dimension_${dimensionId}_training_resource`} /></h5>
      </div>
    )
  }

  renderDimensionPages(){
    const orderedDimensionCategories = this.orderedDimensionCategories();

    let strongestDimensions = [];
    let weakestDimensions = [];

    let pageNumberForDimension = this.getPageOffsetForTbars() - 1;

    _.each(orderedDimensionCategories, dimensionCategory => {
      strongestDimensions.push(dimensionCategory.dimensions[0].id);
      weakestDimensions.push(dimensionCategory.dimensions[dimensionCategory.dimensions.length - 1].id);
    });

    return (
      <React.Fragment>
        {_.map(DIMENSION_CATEGORY_IDS, categoryId => {
          const categoryDimensions = getDimensionsForCategory(this.getScoredDimensionIds(), categoryId);

          return (
            <React.Fragment
              key={categoryId}>
              {_.map(categoryDimensions, dimension => {

                pageNumberForDimension++;

                const isStrongest = strongestDimensions.indexOf(dimension) !== -1;
                const isWeakest = weakestDimensions.indexOf(dimension) !== -1;

                return this.renderDimensionPage(getDimensionFromId(dimension), pageNumberForDimension, isStrongest, isWeakest);
              })}
            </React.Fragment>
          )
          return (
            <div className="page playbook-v2">
              <div className={`report-page dimension-page ${getCategoryNameFromId(categoryId)}`}>
                <div className="chart-for-dimension">
                </div>
              </div>
            </div>
          )
        })}
      </React.Fragment>
    )
  }

  renderDimensionPage(dimension, pageNumber, isStrongest = false, isWeakest = false){

    return (
      <div
        key={`dimension_${dimension.id}_page`}
        className="page playbook-v2">
        <div className={`report-page dimension-page ${getCategoryNameFromId(dimension.categoryId)}`}>
          <div className="chart-for-dimension">
            <div className="chart-container">
              {this.renderDimensionPieChart(this.chartDataForDimensionInCategory(dimension.categoryId))}
            </div>
            <div className="chart-label"><Localize id={`dimension_category_${dimension.categoryId}_playbook_section_label`}>Category Strengths & Strategies</Localize></div>
          </div>

          <div className="dimension-score"></div>

          <h2>{this.getDimensionLabel(dimension.id)}</h2>

          {isStrongest &&
            <div className="relative-strength-label">STRONGEST <Localize id={`dimension_category_${dimension.categoryId}_label`}>Missing</Localize> TALENT</div>
          }
          {isWeakest &&
            <div className="relative-strength-label">WEAKEST <Localize id={`dimension_category_${dimension.categoryId}_label`}>Missing</Localize> TALENT</div>
          }

          <div className="dimension-definition">
            <Localize id={`${this.tbarTypeLocalizationPrefix()}dimension_${dimension.id}_definition`} breakType="dot">(Missing)</Localize>
          </div>

          <div className="t-bar">
            <div className="t-bar-heading">
              <div className="t-bar-heading-left"><Localize id="playbook_low_evidence">Low Evidence</Localize></div>
              <div className="t-bar-heading-right"><Localize id="playbook_high_evidence">High Evidence</Localize></div>
            </div>
            <div className="t-bar-content">
              <ul className="t-bar-content-left">
                <li><Localize id="playbook_without_talent">Without a compensating talent</Localize>:</li>
                <Localize id={`${this.tbarTypeLocalizationPrefix()}dimension_${dimension.id}_low_evidence`} breakType="list">(Missing)</Localize>
              </ul>
              <ul className="t-bar-content-right">
                <li><Localize id="playbook_applied_developed">When applied/developed</Localize>:</li>
                <Localize id={`${this.tbarTypeLocalizationPrefix()}dimension_${dimension.id}_high_evidence`} breakType="list">(Missing)</Localize>
              </ul>
            </div>
          </div>

          <div className="leverage-and-manage">
            <ul>
              <li><Localize id="playbook_leverage_when_high">How to Leverage when it’s High:</Localize></li>
              <Localize id={`${this.tbarTypeLocalizationPrefix()}dimension_${dimension.id}_high_leverage`} breakType="list">(Missing)</Localize>
            </ul>
            <ul>
              <li><Localize id="playbook_manage_when_low">How to Manage when it’s Low:</Localize></li>
              <Localize id={`${this.tbarTypeLocalizationPrefix()}dimension_${dimension.id}_low_manage`} breakType="list">(Missing)</Localize>
            </ul>
          </div>
          <div className="bottom-section">
            {this.renderDimensionsTrainingResource(dimension.id)}
            {this.renderAssociatedSellingCompetencyForDimension(dimension.id)}
          </div>
          {this.renderFooterForPage(pageNumber)}
        </div>
      </div>
    )
  }

  renderCompetenciesIntroPage(){

    const competencies = sellingCompetencies();

    return (
      <div className="page playbook-v2">
        <div className="report-page competencies-intro-page">
          <img className="report-logo" src={this.companyLogo()} alt={this.companyName()} />
          <h2>AuctusIQ Selling Competencies</h2>
          <p>
            <Localize id={`playbook_competencies_intro_${this.talentProfileType()}`} breakType="paragraph">(Missing)</Localize>
          </p>
          <div className="competencies-overview">
            <h2>Our 10 Selling Competencies</h2>
            <div className="competency-items">
              {_.map(competencies, (competency, index) => {
                return (
                  <div key={`competency-${index}`} className="competency-item">
                    <div className="name">{competency.name}</div>
                    <div className="number">{index + 1}</div>
                    {getIcon('competency-badge')}
                  </div>
                )
              })}
            </div>
          </div>

          <p>
            <Localize id={`playbook_competencies_framework_txt_${this.talentProfileType()}`} breakType="paragraph">(Missing)</Localize>
          </p>

          {this.renderFooterForPage(2)}
        </div>
      </div>
    )
  }

  renderTalentsIntroPage(){
    return (
      <div className="page playbook-v2">
        <div className="report-page talents-intro-page">
          <img className="report-logo" src={this.companyLogo()} alt={this.companyName()} />
          <h2>{this.companyName()} {this.talentProfileLabel()}</h2>
          <p>
            <Localize id={`playbook_intro_${this.talentProfileType()}`} breakType="paragraph" replaceWith={this.localizedTalentProfileNameWithCompany()}>(Missing)</Localize>
          </p>
          <div className="dimensions-overview">
            <img className="dimensions-overview-image" src={dimensionsOverview} />
            <div className="dimension-category-labels">
              <div className="label motivation">
                <div className="label-category"><Localize id="dimension_category_1_label" /></div>
                <div className="label-description"><Localize id="txt_talent_category_1_alt" /></div>
              </div>
              <div className="label interaction">
                <div className="label-category"><Localize id="dimension_category_2_label" /></div>
                <div className="label-description"><Localize id="txt_talent_category_2_alt" /></div>
              </div>
              <div className="label cognition">
                <div className="label-category"><Localize id="dimension_category_3_label" /></div>
                <div className="label-description"><Localize id="txt_talent_category_3_alt" /></div>
              </div>
              <div className="label execution">
                <div className="label-category"><Localize id="dimension_category_4_label" /></div>
                <div className="label-description"><Localize id="txt_talent_category_4_alt" /></div>
              </div>
            </div>
            <div className="dimensions-labels">
              {_.map(DIMENSION_CATEGORY_IDS, categoryId => {
                const categoryDimensions = getDimensionsForCategory(this.getScoredDimensionIds(), categoryId);

                return (
                  <div key={`category-dimension-list-${categoryId}`} className={`category ${getCategoryNameFromId(categoryId)}`}>
                    <ul className="dimensions-list">
                      {_.map(categoryDimensions, dimension => {
                        return (
                          <li key={`category-dimension-list-item-${dimension}`}><span>{this.getDimensionLabel(dimension)}</span>&nbsp;</li>
                        )
                      })}
                    </ul>
                  </div>
                )
              })}
            </div>
          </div>
          {this.renderFooterForPage(3)}
        </div>
      </div>
    )
  }

  getPageOffsetForTbars(){
    const firstCategoryOffset = 11;

    return firstCategoryOffset;
  }

  getPageOffsetForCategory(categoryId){
    const firstCategoryOffset = 11;
    let categoryDimensionsBeforeCurrentCategory = 0;

    if(categoryId === '1'){
      //no adjustments
    }
    else if(categoryId === '2'){
      categoryDimensionsBeforeCurrentCategory = _.size(_.union(
        getDimensionsForCategory(this.getScoredDimensionIds(), '1')
      ));
    }
    else if(categoryId === '3'){
      categoryDimensionsBeforeCurrentCategory = _.size(_.union(
        getDimensionsForCategory(this.getScoredDimensionIds(), '1'),
        getDimensionsForCategory(this.getScoredDimensionIds(), '2')
      ));
    }
    else if(categoryId === '4'){
      categoryDimensionsBeforeCurrentCategory = _.size(_.union(
        getDimensionsForCategory(this.getScoredDimensionIds(), '1'),
        getDimensionsForCategory(this.getScoredDimensionIds(), '2'),
        getDimensionsForCategory(this.getScoredDimensionIds(), '3')
      ));
    }

    return firstCategoryOffset + categoryDimensionsBeforeCurrentCategory;
  }
  getPageOffsetForPlanningGuide(){
    const firstCategoryOffset = 11;
    return firstCategoryOffset + _.size(this.getScoredDimensionIds());
  }

  renderTableOfContents(){
    return (
      <div className="page playbook-v2">
        <div className="report-page toc-page">
          <div className="toc-heading">
            <img className="report-title-logo" src={this.companyLogoDark()} />
            <h2><Localize id={`playbook_name`}>Playbook</Localize><br/><small><Localize id="txt_label_toc">Table Of Contents</Localize></small></h2>
          </div>
          <div className="toc-list">
            <h6><Localize id="txt_label_yourresults">Your Results</Localize></h6>
            <div className="toc-item">
              <div className="page-number"><Localize id="txt_label_page">Page</Localize> 5</div>
              <div className="page-description"><Localize id={`txt_label_report_kys`}>Know Your Strengths</Localize></div>
            </div>
            <div className="toc-item">
              <div className="page-number"><Localize id="txt_label_page">Page</Localize> 10</div>
              <div className="page-description"><Localize id={`txt_label_report_ptys`}>Play To Your Strengths</Localize></div>
            </div>
            <h6><Localize id="txt_label_leveragestrengths">Leverage Your Strengths</Localize></h6>
            <div className="toc-item">
              <div className="page-number"><Localize id="txt_label_page">Page</Localize> {this.getPageOffsetForCategory('1')}</div>
              <div className="page-description"><Localize id={`dimension_category_1_playbook_section_label`}>Motivation Strengths & Strategies</Localize></div>
            </div>
            <div className="toc-item">
              <div className="page-number"><Localize id="txt_label_page">Page</Localize> {this.getPageOffsetForCategory('2')}</div>
              <div className="page-description"><Localize id={`dimension_category_2_playbook_section_label`}>Interaction Strengths & Strategies</Localize></div>
            </div>
            <div className="toc-item">
              <div className="page-number"><Localize id="txt_label_page">Page</Localize> {this.getPageOffsetForCategory('3')}</div>
              <div className="page-description"><Localize id={`dimension_category_3_playbook_section_label`}>Cognition Strengths & Strategies</Localize></div>
            </div>
            <div className="toc-item">
              <div className="page-number"><Localize id="txt_label_page">Page</Localize> {this.getPageOffsetForCategory('4')}</div>
              <div className="page-description"><Localize id={`dimension_category_4_playbook_section_label`}>Execution Strengths & Strategies</Localize></div>
            </div>
            <h6><Localize id="txt_label_performanceplanning">Performance Planning</Localize></h6>
            <div className="toc-item">
              <div className="page-number"><Localize id="txt_label_page">Page</Localize> {this.getPageOffsetForPlanningGuide()}</div>
              <div className="page-description">{this.companyName()} <Localize id={`txt_label_playbookguide`}>Playbook Guide</Localize></div>
            </div>
            <div className="toc-item">
              <div className="page-number"><Localize id="txt_label_page">Page</Localize> {this.getPageOffsetForPlanningGuide() + 1}</div>
              {/*<div className="page-description">Performance Planning Journal For {this.companyName()} <Localize id={`talent_profile_${this.talentProfileId()}_label`}>(Missing)</Localize></div>*/}
              <div className="page-description"><Localize id={`playbook_performance_plan_heading`}>Quarterly Performance Planning Journal</Localize></div>
            </div>
            {this.userCompetitiveAdvantages() &&
              <div className="toc-item">
                <div className="page-number"><Localize id="txt_label_page">Page</Localize> {this.getPageOffsetForPlanningGuide() + 5}</div>
                <div className="page-description"><Localize id={`playbook_competitive_advantages_heading`} /></div>
              </div>
            }
          </div>
          {this.renderFooterForPage(4)}
        </div>
      </div>
    )
  }

  localizedTalentProfileName(){
    return localizeToString(this.props.activeLocalization, `talent_profile_${this.talentProfileId()}_label`);
  }
  localizedTalentProfileNameWithCompany(){
    return this.companyName() + ' ' + this.localizedTalentProfileName();
  }

  renderPlaybookGuidePage(){
    return (
      <div className="page playbook-v2">
        <div className="report-page playbook-guide">
          <img className="report-logo" src={this.companyLogo()} alt={this.companyName()} />
          <h2>{this.companyName()} <Localize id={`txt_label_playbookguide`}>Playbook Guide</Localize></h2>
          <p className="playbook-instructions">
            <Localize id={`playbook_performance_planning_instructions_${this.talentProfileType()}_v2`} breakType="steps" replaceWith={this.localizedTalentProfileNameWithCompany()}>(Missing)</Localize>
          </p>

          {this.renderFooterForPage(this.getPageOffsetForPlanningGuide())}
        </div>
      </div>
    )
  }

  strongestDimensionsForCategories(){
    const orderedDimensionCategories = this.orderedDimensionCategories();

    const strongestDimensions = _.map(DIMENSION_CATEGORY_IDS, categoryId => {

      const matchingCategory = _.find(orderedDimensionCategories, { id: categoryId});

      const strongDimensionId = matchingCategory.dimensions[0].id;

      return localizeToString(this.props.activeLocalization, [`dimension_label_${strongDimensionId}_for_profile_${this.talentProfileId()}`, `dimension_label_${strongDimensionId}`]);
    });


    return strongestDimensions.join(', ');
  }
  weakestDimensionsForCategory(){
    const orderedDimensionCategories = this.orderedDimensionCategories();

    const strongestDimensions = _.map(DIMENSION_CATEGORY_IDS, categoryId => {

      const matchingCategory = _.find(orderedDimensionCategories, { id: categoryId});

      const weakDimensionId = matchingCategory.dimensions[matchingCategory.dimensions.length - 1].id;

      return localizeToString(this.props.activeLocalization, [`dimension_label_${weakDimensionId}_for_profile_${this.talentProfileId()}`, `dimension_label_${weakDimensionId}`]);
    });


    return strongestDimensions.join(', ');
  }

  renderPerformancePlanningPages(){

    return (
      <React.Fragment>
        {_.map([1,2,3,4], num => {

          const offsetForPlanningGuide = this.getPageOffsetForPlanningGuide();

          return (
            <div key={`performance-plan-page-${num}`} className="page playbook-v2">
              <div className="report-page performance-plan">
                <div className="plan-header">
                  <Localize id={`playbook_performance_plan_heading`}>Quarterly Sales Performance Planning Journal</Localize>
                </div>
                <div className="goals">
                  <div className="prompt">
                    <Localize id={`playbook_performance_plan_goal_prompt`}>Record your top 1-2 goals and associated target metrics:</Localize>
                  </div>
                  <div className="label-left">
                    <Localize id={`playbook_performance_plan_goal_label`}>Priority goals</Localize>
                  </div>
                  <div className="label-right">
                    <Localize id={`playbook_performance_plan_metric_label`}>Target metrics</Localize>
                  </div>
                  <div className="item-label-left extra-tall"></div>
                  <div className="item-label-left extra-tall"></div>
                </div>
                <div className="leverage-strengths">
                  <div className="prompt">
                    <Localize
                      id={`playbook_performance_plan_leverage_strengths_prompt`}
                    >Explain how will you apply two of your top talents to accomplish your goals…</Localize>
                    <br/><small>{this.strongestDimensionsForCategories()}</small>
                  </div>
                  <div className="item-label-left">
                    <div className="label"><Localize id="playbook_performance_plan_leverage_strengths_talent_label">Talent</Localize> 1</div>
                  </div>
                  <div className="item-label-left">
                    <div className="label"><Localize id="playbook_performance_plan_leverage_strengths_talent_label">Talent</Localize> 2</div>
                  </div>
                </div>
                <div className="compensate-weaknesses">
                  <div className="prompt">
                    <Localize
                      id={`playbook_performance_plan_compensate_weaknesses_prompt`}
                    >What new skills will you develop in order to compensate for your weakest talents to accomplish your goals?</Localize>
                    <br/><small>{this.weakestDimensionsForCategory()}</small>
                  </div>
                  <div className="item-label-left">
                    <div className="label"><Localize id="playbook_performance_plan_compensate_weaknesses_skill_label">Skill</Localize> 1</div>
                  </div>
                  <div className="item-label-left">
                    <div className="label"><Localize id="playbook_performance_plan_compensate_weaknesses_skill_label">Skill</Localize> 2</div>
                  </div>
                </div>
                {this.renderFooterForPage(offsetForPlanningGuide + num)}
              </div>
            </div>
          )
        })}
      </React.Fragment>
    )
  }

  userCompetitiveAdvantages(){
    const dimensionsAboveBenchmark = scoreCompetitiveAdvantagesForTalentProfile(this.talentProfileId(), this.scores());

    return dimensionsAboveBenchmark && dimensionsAboveBenchmark.length > 0 ? dimensionsAboveBenchmark : false;
  }

  renderCompetitiveAdvantage(advantage){
    return (
      <li key={`advantage-for-dimension-${advantage.dimension}`}>
        <h4>{this.getDimensionLabel(advantage.dimension)}</h4>
        <div className="above-benchmark"><small>+</small>{advantage.percentAbove}<small>%</small></div>
        <div className="benchmark-explanation"><Localize id="txt_label_abovetopperformers">Above Top Performers</Localize></div>
        <p><Localize id={`${this.tbarTypeLocalizationPrefix()}dimension_${advantage.dimension}_definition`} breakType="dot" /></p>
      </li>
    );
  }
  renderCompetitiveAdvantagesReport(){
    const competitiveAdvantages = this.userCompetitiveAdvantages();

    if(!competitiveAdvantages){ return null; }

    return (
      <div className="page playbook-v2">
        <div className="report-page">
          <img className="report-logo" src={this.companyLogo()} alt={this.companyName()} />
          <h1><Localize id={`playbook_competitive_advantages_heading`} /><br/>{this.renderPreparedFor()}</h1>
          <p>
            <Localize id={`playbook_competitive_advantages_intro`} replaceWith={this.localizedTalentProfileName()} />
          </p>
          <ul className="benchmarks">
            {_.map(competitiveAdvantages, this.renderCompetitiveAdvantage.bind(this))}
          </ul>
          {this.renderFooterForPage(this.getPageOffsetForPlanningGuide() + 5)}
        </div>
      </div>
    );

  }

  renderPreparedFor(){
    return (
      <span className="prepared-for" style={{textTransform: 'capitalize'}}>{this.userName()}</span>
    );
  }


  render(){

    const { reportData, orgConfig, activeLocalization } = this.props;

    const orderedDimensionCategories = this.orderedDimensionCategories();

    const resultsLoaded = orgConfig && activeLocalization && reportData && reportData.scores && orderedDimensionCategories;

    return (
      <div id="assessment-results" className="assessment-results">
        <div className="content-wrapper">
          {!resultsLoaded && this.renderLoadingMessage()}

          {resultsLoaded && this.renderTitlePage()}
          {resultsLoaded && this.renderCompetenciesIntroPage()}
          {resultsLoaded && this.renderTalentsIntroPage()}
          {resultsLoaded && this.renderTableOfContents()}
          {resultsLoaded && this.renderKnowYourStrengthsReport()}
          {resultsLoaded && this.renderPlayToYourStrengthsReport()}
          {resultsLoaded && this.renderDimensionPages()}
          {resultsLoaded && this.renderPlaybookGuidePage()}
          {resultsLoaded && this.renderPerformancePlanningPages()}
          {resultsLoaded && this.renderCompetitiveAdvantagesReport()}
        </div>
      </div>
    )
  }
}

export default PlaybookReport;



// WEBPACK FOOTER //
// ./src/components/export/playbook_v2.js